import React, { useState, useRef, useEffect } from 'react';
import { useTouchClick } from "shared/hooks/useTouchClick";
import BrandsCategoryButtons from '../category/BrandsCategoryButtons';
import BrandCard from '../card/BrandCard';
import SimplePagination from '../pagination/SimplePagination';
import SkeletonBrandCard from '../card/SkeletonBrandCard';
import categorySound from "resources/music/물방울.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";
import BackButton from '../Button/BackButton';
import BrandsCategoryButtons2 from '../category/BrandsCategoryButtons2';
import HorizontalBackButton from '../Button/HorizontalBackButton';
import StretchableHorizontalSlider from '../pagination/StretchableHorizontalSlider';

function HorizontalBrandList({
    brands,
    setBrands,
    filteredBrands,
    setFilteredBrands,
    onBrandSelect,
    brandVisible,
    setBrandVisible,
    setShowBrandProducts,
    setFilteredProducts,
    onCategorySelect,
    onBackClick,
    setShowExhibition,
    leftIcon,
    rightIcon,
    setViewData,
    currentBrandPage,
    setCurrentBrandPage,
    onGoBackBtnClick,
    isLoading,
    shouldShowSkeleton
}) {
    const brandsItemsPerPage = 6;
    const totalBrandPages = Math.ceil(filteredBrands.length / brandsItemsPerPage);
    const audioRef = useRef();
    const audio1Ref = useRef();

    const brandTypeMap = {
        DISPOSABLEDEVICE: '일회용',
        DEVICE: '기기',
        LIQUID: '액상',
        null: '기타',
    };

    const handleBrandPageChange = (direction) => {
        if (direction === 'prev' && currentBrandPage > 1) {
            audio1Ref.current.play();
            setCurrentBrandPage(prev => prev - 1);
        } else if (direction === 'next' && currentBrandPage < totalBrandPages) {
            audio1Ref.current.play();
            setCurrentBrandPage(prev => prev + 1);
        }
    };

    const getCurrentBrandItems = () => {
        // Show skeleton brand cards when loading
        if (isLoading && shouldShowSkeleton) {
            return Array.from({ length: brandsItemsPerPage }).map((_, index) => ({
                type: 'skeleton',
                key: `skeleton-brand-${index}`,
                isLoading: true
            }));
        }

        const startIndex = (currentBrandPage - 1) * brandsItemsPerPage;
        const currentItems = filteredBrands.slice(startIndex, startIndex + brandsItemsPerPage);

        // Check if any items are skeleton type from initial loading
        const hasSkeletonItems = currentItems.some(item => item.type === 'skeleton');

        // If there are skeleton items from initial loading but isLoading is false,
        // return empty dummy slots
        if (hasSkeletonItems && !isLoading) {
            return Array.from({ length: brandsItemsPerPage }).map((_, index) => ({
                type: 'skeleton',
                key: `dummy-brand-${index}`,
                isLoading: false,
                isDummy: true
            }));
        }

        // 현재 아이템의 개수가 6개보다 적다면 더미 요소 추가
        if (currentItems.length < brandsItemsPerPage) {
            const dummyCount = brandsItemsPerPage - currentItems.length;
            const dummyElements = Array.from({ length: dummyCount }).map((_, index) => ({
                type: 'skeleton',
                key: `dummy-brand-${index}`,
                isDummy: true
            }));

            return [...currentItems, ...dummyElements];
        }

        return currentItems;
    };

    const handleCategorySelect = (selectedCategory) => {
        const selectedType = Object.keys(brandTypeMap).find(key => brandTypeMap[key] === selectedCategory);
        audioRef.current.play();
        if (selectedType) {
            const filtered = brands.filter(brand => brand.brandType === selectedType);
            setFilteredBrands(filtered);
        } else {
            setFilteredBrands(brands);  // 선택 안 된 경우 전체 목록
        }
        setCurrentBrandPage(1);
    };

    // Paging data for StretchableHorizontalSlider
    const pagingData = {
        hasPrevious: currentBrandPage > 1,
        hasNext: currentBrandPage < totalBrandPages
    };

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
                position: "relative",
                marginTop: '90px',
            }}
        >
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <audio ref={audio1Ref} src={btnSound} preload="auto" />

            <div style={{ position: 'absolute', top: '-80px', width: '93%' }}>
                <BrandsCategoryButtons2
                    brands={brands}
                    onCategorySelect={handleCategorySelect}
                    setFilteredBrands={setFilteredBrands}
                />
            </div>

            <StretchableHorizontalSlider
                pagingData={pagingData}
                onPageChange={handleBrandPageChange}
                width="93%"
                brand
            >
                {getCurrentBrandItems().map((brand, index) => {
                    if (brand.type === 'skeleton') {
                        return (
                            <div
                                key={brand.key}
                                style={{
                                    width: "calc(32.3%)",
                                    opacity: brand.isDummy ? 0 : 1,
                                    pointerEvents: brand.isDummy ? "none" : "auto",
                                    visibility: brand.isDummy ? 'hidden' : 'visible'
                                }}
                            >
                                <SkeletonBrandCard 
                                    isLoading={brand.isLoading} 
                                    isDummy={brand.isDummy} 
                                />
                            </div>
                        );
                    }

                    return (
                        <BrandCard
                            data={brand}
                            key={index}
                            setFilteredProducts={setFilteredProducts}
                            setBrands={setBrands}
                            currentBrandPage={currentBrandPage}
                            setCurrentBrandPage={setCurrentBrandPage}
                            showBrandProducts={setShowBrandProducts}
                            setShowBrandProducts={setShowBrandProducts}
                            setSelectedCategory={onCategorySelect}
                            setShowExhibition={setShowExhibition}
                            setBrandVisible={setBrandVisible}
                            setViewData={setViewData}
                            horizontal={true}
                        />
                    );
                })}
            </StretchableHorizontalSlider>

            <HorizontalBackButton onGoBackBtnClick={onGoBackBtnClick} brand/>
            <div style={{transform: 'translateX(50px)'}}>    
            <SimplePagination
                currentPage={currentBrandPage}
                totalPages={totalBrandPages}
                onPageChange={handleBrandPageChange}
                leftIcon={leftIcon}
                rightIcon={rightIcon}
                bottom="7vh"
            />
            </div>
        </div>
    );
}

export default HorizontalBrandList;
